module.exports = __webpack_public_path__ + "static/media/star.a66e32f8.svg";